import React, { forwardRef, memo, useContext } from 'react';
import Radio from './radio';
import RadioContext from './RadioContext';
const RadioButton = forwardRef((props, ref) => {
    const { radioGroup, getPrefixCls } = useContext(RadioContext);
    const radioProps = { ...props };
    if (radioGroup) {
        radioProps.checked = props.value === radioGroup.value;
        radioProps.disabled = props.disabled || radioGroup.disabled;
    }
    return React.createElement(Radio, Object.assign({ prefixCls: getPrefixCls('radio-button') }, radioProps, { ref: ref }));
});
RadioButton.displayName = 'RadioButton';
export default memo(RadioButton);
